import { render, staticRenderFns } from "./Anexos.vue?vue&type=template&id=58eb9f57&"
import script from "./Anexos.vue?vue&type=script&lang=js&"
export * from "./Anexos.vue?vue&type=script&lang=js&"
import style0 from "./Anexos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports